module.exports = __webpack_public_path__ + "static/img/3.9c6868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/3.png
// module id = 2Db9
// module chunks = 35